import React from "react";
import { NavLink } from "react-router-dom";

function HeaderLink(props) {
  return (
    <NavLink
      style={{
        height: "50px",
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
      activeStyle={{ width: "120%" }}
      to={props.linkTo}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          borderBottom: "1px solid #ebebeb",
          width: "70%",
          justifyContent: "flex-start",
        }}
      >
        <img style={{ display: "flex", width: "30px" }} src={props.icon} />
        <span
          style={{
            display: "flex",
            fontSize: "16px",
            fontFamily: "Source Sans Pro",
            padding: 5,
            color: "white",
          }}
        >
          {props.title}
        </span>
      </div>
    </NavLink>
  );
}

export default HeaderLink;
